import DuckEntity from './DuckEntity';

export const entity = new DuckEntity('globalWidgets');
export default entity.reducer;
